import script from "./TipsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TipsPage.vue?vue&type=script&setup=true&lang=js"

import "./TipsPage.vue?vue&type=style&index=0&id=82834438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82834438"]])

export default __exports__